import React, { useState, createContext } from "react";
import "./App.css";
import "./index.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";

import Sidenav from "./componants/Side Navbar/Sidenav";
import Login from "./componants/Auth/Login";
import Home from "./componants/Home/Home";
import Profile from "./componants/Profile/Profile";
import Navbar from "./componants/Navbar/Navbar";
import Admin from "./componants/Admin/Admin";
import AdminFaq from "./componants/FAQ/AdminFaq/FAQ";
import EmployeeFaq from "./componants/FAQ/EmployeeFaq/EmployeeFaq";
import About from "./componants/About Us/About";
import Privacy from "./componants/Privacy Policies/Privacy";
import Terms from "./componants/Terms & Condition/Terms";
import Clinic from "./componants/Clinic/Clinic";
import HelpAndSupport from "./componants/Help & Support/HelpAndSupport";
import Cases from "./componants/Cases/Cases";
import AdminBanners from "./componants/Admin/Banners/AdminBanners";
import AdminContent from "./componants/Admin/Content/AdminContent";
import AdminStories from "./componants/Admin/Stories/AdminStories";
import AdminSubscriptions from "./componants/Admin/Subscriptions/AdminSubscriptions";
import AddBannerPage from "./componants/Admin/Banners/AddBannerPage";
import AddContentPage from "./componants/Admin/Content/AddContentPage";
import AddStoryPage from "./componants/Admin/Stories/AddStoryPage";
import AddSubscriptionPage from "./componants/Admin/Subscriptions/AddSubscriptionPage";
import PolicyPage from "./componants/PublicContent/PolicyPage";
import DeleteUserPage from "./componants/PublicContent/DeleteUserPage";

export const UserContext = createContext();

function App() {
  const [isOpen, setIsOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    localStorage.getItem("token") ? true : false,
  );

  const toggleSidenav = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <Router>
      <UserContext.Provider value={{ setIsAuthenticated, isAuthenticated }}>
        <Routes>
          <Route
            path="/terms-conditions"
            element={<PolicyPage slug="terms-and-conditions" />}
          />
          <Route
            path="/privacy-policy"
            element={<PolicyPage slug="privacy-policy" />}
          />
          <Route path="/delete-user" element={<DeleteUserPage />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                <AuthenticatedApp
                  isOpen={isOpen}
                  toggleSidenav={toggleSidenav}
                />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </UserContext.Provider>
    </Router>
  );
}

const AuthenticatedApp = ({ isOpen, toggleSidenav }) => {
  const location = useLocation();

  return (
    <div className="flex h-screen overflow-y-scroll scrollbar-hidden">
      <Sidenav isOpen={isOpen} />

      <div
        className={`flex-1 transition-all duration-300 ${
          isOpen ? "ml-64" : "ml-0"
        } `}
      >
        {<Navbar toggleSidenav={toggleSidenav} isSidenavOpen={isOpen} />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="admin/profile" element={<Profile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/banners" element={<AdminBanners />} />
          <Route path="/admin/banners/add" element={<AddBannerPage />} />
          <Route path="/admin/content" element={<AdminContent />} />
          <Route path="/admin/content/add" element={<AddContentPage />} />
          <Route path="/admin/stories" element={<AdminStories />} />
          <Route path="/admin/stories/add" element={<AddStoryPage />} />
          <Route path="/admin/subscriptions" element={<AdminSubscriptions />} />
          <Route
            path="/admin/subscriptions/add"
            element={<AddSubscriptionPage />}
          />
          <Route path="/FAQ/admin" element={<AdminFaq />} />
          <Route path="/FAQ/employee" element={<EmployeeFaq />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/admin/privacy-policy" element={<Privacy />} />
          <Route path="/admin/terms-conditions" element={<Terms />} />
          <Route path="/clinic" element={<Clinic />} />
          <Route path="/help&support" element={<HelpAndSupport />} />
          <Route path="/cases" element={<Cases />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
